var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fields.title && _vm.fields.title.value)?_c('ScText',{attrs:{"field":_vm.fields.title,"tag":"CycleHeading","weight":1}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }